// Add your custom JS here.

jQuery(document).ready(function($){
	$('.homepage-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		prevArrow: '<a class="slick-prev slick-arrow position-absolute top-50 translate-middle"></a>',
		nextArrow: '<a class="slick-next slick-arrow position-absolute top-50 translate-middle"></a>',
	});
});